import metrics from 'maps/metrics';

export default getTableHeaders;

interface ITableHeader {
  label: string;
  value: string;
  type?: string;
}

function getTableHeaders(tagsType: string): ITableHeader[] {
  const defaults = [
    { ...metrics['countThisWeekToDate'], label: 'This week\nto date' },
    { ...metrics['countLastWeek'], label: 'Last full\nweek' },
  ];

  switch (tagsType) {
    case 'countries':
      return [
        { label: 'country', value: 'countryName' },
        { label: 'trend', value: 'trendLine', type: 'trend' },
        ...defaults,
        { label: 'expand', value: 'expand' },
      ];
    case 'cities':
    default:
      return [
        { label: 'city', value: 'cityName' },
        { label: 'state', value: 'stateName' },
        { label: 'country', value: 'countryName' },
        { label: 'trend', value: 'trendLine', type: 'trend' },
        ...defaults,
      ];
  }
}
